import $ from "jquery";
import SplitTextJS from "split-text-js";
import Screen from "./screen";
import { breakpointMD } from "../_variables";
import { gsap, TweenMax } from "gsap";
export default class Top {
  constructor() {
    this.screen = new Screen();
  }

  init() {
    if (!(document.querySelector('body').getAttribute('id') === 'top')) { return; }
    const $screenLoad = $(".screen-load");
    const videosOnDOMLoaded = ['bgvid'];
    const videosOnAllLoaded = ['aboutas'];
    window.addEventListener("load", () => {
      //check localstorage
      const visited = this.checkLocalstorage();
      if (visited) {
        $screenLoad.remove();
        $screenLoad.fadeOut(800)
        this.pageStart();
      } else {
        this.screenLoad($screenLoad);
      }
    });
    window.addEventListener("DOMContentLoaded", () => {
      videosOnDOMLoaded.forEach(video => {
        this.setVideoSrc(document.getElementById(video));
      });
      return
    });
    window.addEventListener("load", () => {
      videosOnAllLoaded.forEach(video => {
        this.setVideoSrc(document.getElementById(video));
        videosOnDOMLoaded.push(video);
      });
      return
    });
    window.addEventListener("resize", () => {
      videosOnDOMLoaded.forEach(video => {
        this.setVideoSrc(document.getElementById(video));
      });
    });
  }

  setVideoSrc(video) {
    if (video === null) {
      return
    }
    const videoSrc = video.querySelector('source');
    let device = this.screen.isPC ? '_pc' : '_sp';
    let dataSrc = video.getAttribute('data-src');
    if (videoSrc.getAttribute('src') === `${dataSrc}${device}.mp4`) {
      return;
    } else {
      video.innerHTML = '';
      video.innerHTML = `<source src="${dataSrc}${device}.mp4" type="video/mp4">`;
    }
  }

  playFlareVideo() {
    document.getElementById('bgvid').play();
  }

  screenLoad($screenLoad) {
    $screenLoad.children().css("visibility", "visible");
    const $top = $("#top-load");
    if ($top.length === 0) {
      return;
    }

    $(window).scrollTop(0);
    this.screen.lock();

    const intervalLoad = setInterval(() => {
      if ($screenLoad.find("video").get(0).currentTime > 0) {
        $screenLoad.find('.progress').css('display', 'flex')
      }
      if ($screenLoad.find("video").get(0).ended) {
        clearInterval(intervalLoad);
        setTimeout(() => {
          $screenLoad.remove();
        }, 1000);
        $screenLoad.fadeOut(800);
        $top.fadeIn(2000);
        this.screen.unlock();
        this.pageStart();
      }
    }, 500);
  }

  pageStart() {
    this.textWave();
    this.topParallax();
    this.playFlareVideo();
  }

  checkLocalstorage() {
    if (!window.localStorage.getItem("visited")) {
      window.localStorage.setItem("visited", true);
      return false;
    } else {
      return true;
    }
  }

  textWave() {
    const animation = gsap.timeline({});
    const boxTarget = ".p-mainimg-top .box-title";

    if (this.screen.isPC) {
      const text = document.querySelectorAll(".p-mainimg-top .-wave-pc");
      const configText = [
        { y: 15, duration: 0.33, delay: 1 },
        { y: 15, duration: 0.33, delay: -0.33 },
        { y: 10, duration: 0.33, delay: 0 },
      ];

      text.forEach((val, idx) => {
        const split = new SplitTextJS(val);
        gsap.set(boxTarget, { autoAlpha: 1 });
        animation.from(split.chars, {
          opacity: 0,
          y: configText[idx].y,
          ease: "linear",
          stagger: {
            from: "start",
            each: 0.04,
          },
          delay: configText[idx].delay,
          duration: configText[idx].duration,
        });
      });
    } else {
      const text = document.querySelectorAll(".p-mainimg-top .-wave-sp");
      const configText = [
        { y: 10, duration: 0.33, delay: 2 },
        { y: 10, duration: 0.33, delay: -0.33 },
        { y: 10, duration: 0.33, delay: -0.33 },
        { y: 10, duration: 0.5, delay: 0.25 },
      ];

      text.forEach((val, idx) => {
        const split = new SplitTextJS(val);
        gsap.set(boxTarget, { autoAlpha: 1 });
        animation.from(split.chars, {
          opacity: 0,
          y: configText[idx].y,
          ease: "linear",
          stagger: {
            from: "start",
            each: 0.05,
          },
          delay: configText[idx].delay,
          duration: configText[idx].duration,
        });
      });
    }
  }

  topParallax() {
    const $target = $(".js-top-parallax");

    if (!$target.length) {
      return;
    }

    const $item = $target.children(".js-parallax-item");

    $(window).on("scroll", function () {
      if ($(window).innerWidth() <= breakpointMD) {
        $item.removeAttr("style");
        return;
      }

      const offset = $target.offset().top;
      const scrollTop = $(window).scrollTop();
      const posX = Math.floor((scrollTop - offset) / 5);

      $item.css({ transform: `translateZ(0) translateY(${posX}px)` });
    });
  }
}
